import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import debounce from 'debounce';
import {
    _schedulerLogs
} from '../../services';
import {
    Row,
    Col,
    Drawer,
    Input,
    Card,
    Button,
    Badge
} from 'antd'
const { Search } = Input;

class SchedulerLogsDrawer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            schedulerLogs: [],
            searchTerm: "",
            latestLogLength: null,
            visible: false,
            lengthDiff: 0
        }
        this.searchLogs = debounce( this.searchLogs , 800 )
    }

    componentDidMount(){

        _schedulerLogs()
            .then(res=>{

                let sortedLogs = res.data.sort((a,b)=>moment(b.dateCreated).diff(a.dateCreated))

                this.setState({
                    schedulerLogs: sortedLogs,
                    latestLogLength: sortedLogs.length
                }, ()=> this.hotReloadLogs() )
            })
    }

    hotReloadLogs = () => {
        
        if(!this.state.visible){
            _schedulerLogs()
            .then(res=>{

                let sortedLogs = res.data.sort((a,b)=>moment(b.dateCreated).diff(a.dateCreated))
                

                let stateRefresh = {}
                
                stateRefresh["lengthDiff"] = sortedLogs.length - this.state.latestLogLength
                

                this.setState(stateRefresh , ()=> setTimeout( this.hotReloadLogs , 5000 ))
            })
        }else{
            ()=> setTimeout( this.hotReloadLogs , 5000 )
        }
       

    }

    render(){

        return(
            <div>
                <Button
                    onClick = {this.toggleLogsDrawer}
                    type="primary"
                    style={{
                        width: "60px",
                        transform: "rotate(-90deg)",
                        position: "fixed",
                        top: "300px",
                        right: "-16px"
                    }}
                >
                    Logs

                </Button>
                    
                <div
                    style={{
                        position: "fixed",
                        top: "277px",
                        right: "19px"
                    }} 
                >
                    <Badge 
                        count={this.state.lengthDiff} 
                        
                    />
                </div>
                
                

                <Drawer
                    mask = { false }
                    placement="right"
                    onClose={this.onClose}
                    visible = { this.state.visible }
                    width = "700px"
                >
                    <Col type="flex" justify="space-around" align="start">
                        <Row style={{paddingBottom:"10px"}} >
                            <Search
                                placeholder="Search Invoice Number"
                                onChange = {(e)=>this.changeInput(e)}
                                value = { this.state.searchTerm }
                                style={{ width: "90%" }}
                            />
                        </Row>
                        {
                            this.state.schedulerLogs.length > 0 &&
                            this.state.schedulerLogs.map((_log, i)=>
                                
                                <Row>
                                    <Card 
                                        size="small" 
                                        title={`${moment(_log.dateCreated).format("DD-MM-YYYY HH:mm:ss")} : ${_log.actionPretty}`} 
                                        style={{ 
                                            width: "90%", 
                                            fontSize: "15px",
                                            backgroundColor: `${ i <= ((this.state.schedulerLogs.length - this.state.latestLogLength) - 1) ? "#ffffb8" : "#ffff" }`
                                        }}>
                                        <Col>
                                            <Row>
                                                { _log.userEmail }
                                            </Row>
                                            <Row>
                                                { _log.actionDescription }
                                            </Row>
                                        </Col>
                                    </Card>
                                </Row>
                                
                            )
                        }
                    </Col>
                </Drawer>
            </div>
        )
    }


    toggleLogsDrawer = () => {
        _schedulerLogs()
            .then(res=>{
                let sortedLogs = res.data.sort((a,b)=>moment(b.dateCreated).diff(a.dateCreated))
                
                this.setState({
                    visible: true,
                    schedulerLogs: sortedLogs
                })
            })
        
    }

    onClose = () => {

        this.setState({
            latestLogLength: this.state.schedulerLogs.length,
            lengthDiff: 0,
            visible: false
        }, ()=> setTimeout( this.hotReloadLogs , 5000 ))
        
    }

    changeInput = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm: searchTerm
        }, this.searchLogs )
        
    }

    searchLogs = ( ) => {
        _schedulerLogs(this.state.searchTerm)
        .then(res=>{
            this.setState({
                schedulerLogs: res.data
            })
        })
    }

    shouldComponentUpdate(nextProps, nextState){
       if( this.state.visible != nextState.visible ){
           return true
       }

       if( this.state.searchTerm != nextState.searchTerm ){
           return true
       }
       if( this.state.lengthDiff != nextState.lengthDiff ){
           return true
       }

       let currentId = this.state.schedulerLogs.map(log=>log._id)
       let incomingId = nextState.schedulerLogs.map(log=>log._id)

       if( currentId.sort().join() != incomingId.sort().join() ){
           return true
       }
       return false
    }

}
export default SchedulerLogsDrawer;


// WEBPACK FOOTER //
// ./src/components/delivery-page/SchedulerLogsDrawer.js